import { AlertCircle } from 'lucide-react'

import { ContactSupportAction } from '@/customer/components/contact-support-action'
import { Alert, AlertAction, AlertDescription, AlertTitle } from '@/customer/components/ui/alert'

/**
 * Terminal error shown when Stripe confirmed payment but the
 * backend status didn't update within the expected window.
 * Not retryable by the member; engineering is notified via Sentry.
 */
export function PaymentReconciliationFailed({ message }: { message: string }) {
  return (
    <Alert variant="destructive">
      <AlertCircle />
      <AlertTitle>{message}</AlertTitle>
      <AlertDescription>
        <p>Our engineering team has been notified about the technical issue.</p>
        <p>In the meantime, reach out to our care team if you need any help.</p>
      </AlertDescription>
      <AlertAction>
        <ContactSupportAction />
      </AlertAction>
    </Alert>
  )
}
